import React from 'react';
import QuestionContainer from './QuestionContainer';
import Question from './Question';

export default (props) => {
    return (
        <QuestionContainer>
            <Question lang={props.lang}/>
        </QuestionContainer>
    )
}


// WEBPACK FOOTER //
// ./src/components/questions/index.jsx